import { useContext } from "react"

import PostContext from "../context/PostContext"

const usePostContext = () => {
    return useContext(PostContext)
}

export default usePostContext
